import { PermissionTypeDto } from "clearline-api";

export const routePermissionsMap: Record<string, PermissionTypeDto> = {
  "/": PermissionTypeDto.Cmc
};
